import * as OpenGraph from "@heliopolis/schema/open-graph.js";
import {
  array,
  date,
  type input,
  object,
  optional,
  type output,
  string,
  unknown,
  url,
} from "zod/v4";

export const RecipeURLCrawlReport = object({
  crawledAt: date(),
  /** Were any issues encountered while parsing the web page */
  issues: optional(array(string())),
  jsonLd: optional(unknown()),
  openGraph: optional(OpenGraph.Meta),
  // TODO: Narrow this to only supported `http://` and `https://` schema
  recipeURL: url(),
});
export interface RecipeURLCrawlReport extends output<typeof RecipeURLCrawlReport> {}

export type RecipeURLCrawlReportInput = input<typeof RecipeURLCrawlReport>;
